






































































































































































































import AdditionIcon from "@/components/Additions/AdditionIcon.vue";
import EmployeeStandByAndUrgentCallnfo from "@/components/EmployeeStandByAndUrgentCallnfo.vue";
import { AppConstants, Models } from "@/core/Export";
import { Component, Prop, Vue } from "vue-property-decorator";

import store from "@/store";
@Component({
  components: { AdditionIcon, EmployeeStandByAndUrgentCallnfo },
})
export default class EmployeeAttendDayViewLine extends Vue {
  @Prop() props: Array<any>;
  @Prop({ default: false }) useNominations: boolean;
  @Prop({ default: false }) isStandBy: boolean;

  permissions: any;
  constructor() {
    super();
    this.permissions = AppConstants.Permissions;
  }

  // created() {

  // }

  onShowApprovalFile(employeeId: number, date: string) {
    store.commit(AppConstants.StoreMutations.UpdateDrawerParams, {
      employeeId: employeeId,
      date: date,
    });
    store.commit(AppConstants.StoreMutations.UpdateIsLeftDrawerOpen, true);
    store.commit(
      AppConstants.StoreMutations.UpdateLeftDrawerComponnent,
      AppConstants.DrawerComponnents.EmployeeApprovalsFiles
    );
  }

  onOpenDayForEdit(day: Models.EAME_DayDto) {
    store.commit(AppConstants.StoreMutations.UpdateDrawerParams, {
      day: day,
      isStandBy: this.isStandBy
    });
    store.commit(AppConstants.StoreMutations.UpdateIsLeftDrawerOpen, true);
    store.commit(
      AppConstants.StoreMutations.UpdateLeftDrawerComponnent,
      AppConstants.DrawerComponnents.EmployeeAttendEditMobile
    );
  }

  onShowEmployeeAttendDayPairs(day: Models.EmployeePairsEntry) {
    if (this.appEnv.UserInfo.isManager && this.isEmployeeDetailsRoute) {
      store.commit(AppConstants.StoreMutations.UpdateDrawerParams, {
        date: day.date,
      });
      store.commit(AppConstants.StoreMutations.UpdateIsLeftDrawerOpen, true);
      store.commit(
        AppConstants.StoreMutations.UpdateLeftDrawerComponnent,
        AppConstants.DrawerComponnents.EmployeeAttendDayApprove
      );
    }
  }

  getHealthDeclarationToolTip(hasHealthDeclarationEnum: number) {
    return this.$t(`health_declaration.${hasHealthDeclarationEnum}`);
  }

  getHealthDeclarationIcon(hasHealthDeclarationEnum: number) {
    if (hasHealthDeclarationEnum == 1) {
      return `img:${require("../assets/images/approved_statement.svg")}`;
    } else if (hasHealthDeclarationEnum == 2) {
      return `img:${require("../assets/images/not_found_statement.svg")}`;
    } else {
      return `img:${require("../assets/images/not_found_statement.svg")}`;
    }
  }

  get numberOfPairs(): number {
    let p: any = this.props as any;
    let dayLines: any = p.row;
    let total: number = 0;
    if (this.useNominations) {      
      total = dayLines.lines.filter(shift => shift.entryTimeText || shift.exitTimeText).length;

      // for (let i: number = 0; i < dayLines.lines.length; i++) {
      //   let line: any = dayLines.lines[i];
      //   if (!Array.isArray(line.lines)) {
      //     continue;
      //   }

      //   total += line.lines.filter(shift => shift.entryTimeText || shift.exitTimeText).length;
      // }
    } else {
      let pairs: Array<any> = dayLines.lines.filter(q => q.typeCode == "P");
      total = pairs.length;
    }

    return total;
  }

  get canEditDay() {
    let empAttendReadyOnly = this.appEnv.isAllowed(
      AppConstants.Permissions.EmpAttendReadyOnly
    );
    let writeLog = this.appEnv.isAllowed(AppConstants.Permissions.WriteLog);
    if (empAttendReadyOnly) {
      return false;
    } else if (
      this.approval.empApprovalDate ||
      this.approval.empManagerApprovalDate
    ) {
      return false;
    } else {
      return writeLog;
    }
  }

  get approval() {
    return this.employeeAttendViewData.approval;
  }

  get healthDeclarationIsVisible() {
    return this.employeeAttendViewData.healthDeclarationIsVisible
  }

  get employeeAttendViewData() {
    return store.getters.employeeAttendViewData;
  }

  get isEmployeeDetailsRoute() {
    return this.$route.name == AppConstants.Routes.M_Employee_Details;
  }

  get isAllowViewAttendAndSummaries() {
    if (
      this.appEnv.isAllowed(
        AppConstants.Permissions.PortalLimitViewAtAttendanceAndSummaries
      )
    ) {
      return false;
    }
    return true;
  }

  get appEnv() {
    return store.getters.appEnv;
  }
}
